import React from "react"
import { graphql, Link, useStaticQuery } from "gatsby"
import { Grid, Header, List } from "semantic-ui-react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const Footer = () => {
  const { image } = useStaticQuery(graphql`
    query {
      image: file(relativePath: { eq: "logos/full_logo_white.png" }) {
        childImageSharp {
          gatsbyImageData(width: 200)
        }
      }
    }
  `)
  return (
    <footer className={"footer"}>
      <Grid stackable centered>
        <Grid.Row>
          <Grid.Column width={3}>
            <GatsbyImage
              style={{ cursor: "pointer" }}
              image={getImage(image)}
              alt={"Art Collection Logo"}
            />
          </Grid.Column>
          <Grid.Column width={3}>
            <Header inverted size="small" content="COMPANY" />
            <List link inverted>
              <List.Item as={Link} to="/about" content={"About Us"} />
              <List.Item as={Link} to="/blog" content={"Blog"} />
              <List.Item
                as="a"
                href="https://angel.co/artcollectionio/jobs"
                target="_blank"
                rel="noopener noreferrer"
              >
                <List.Content>Careers</List.Content>
              </List.Item>
              <List.Item as="a" href="mailto:info@artcollection.io">
                Help
              </List.Item>
              <List.Item as={Link} to="/affiliate" content={"Affiliate"} />
            </List>
          </Grid.Column>

          <Grid.Column width={3}>
            <Header size="small" inverted content="PRODUCTS" />
            <List link inverted>
              <List.Item as={Link} to="/art-advisor" content={"AI Art Advisor"} />
              <List.Item 
                as="a" href="https://database.artcollection.io" 
                target="_blank" 
                rel="noopener noreferrer" 
                content={"Auction Database"}
              />
              <List.Item 
                as="a" href="https://partner.artcollection.io" 
                target="_blank" 
                rel="noopener noreferrer" 
                content={"Art Collection API"}
              />
              <List.Item
                as="a"
                href="https://www.artmaster.io/"
                target="_blank"
                rel="noopener noreferrer"
                content={"Art Master"}
              />
            </List>
            <Header inverted size="small" content="SERVICES" />
            <List link inverted>
              <List.Item
                as={Link}
                to="/valuation"
                content={"Instant Valuations"}
              />
              <List.Item
                as={Link}
                to="/appraisal_request"
                content={"Art Appraisals"}
              />
              <List.Item as={Link} to="/consign" content={"Sell Your Art"} />
            </List>
          </Grid.Column>

          <Grid.Column width={3}>
            <Header inverted size="small" content="LEGAL" />
            <List link inverted>
              <List.Item as={Link} to="/privacy">
                Privacy Policy
              </List.Item>
              <List.Item as={Link} to="/terms">
                Terms of Service
              </List.Item>
            </List>
            <Header inverted size="small" content="INFORMATION" />
            <List link inverted>
              <List.Item as={Link} to="/artist" content={"Artists"} />
              <List.Item as={Link} to="/gallery" content={"Galleries"} />
              <List.Item as={Link} to="/museum" content={"Museums"} />
            </List>
          </Grid.Column>
          <Grid.Column width={3}>
            <Header size="small" inverted content="FOLLOW US" />
            <List link inverted>
              <List.Item
                as="a"
                href="https://www.instagram.com/artcollection.io"
                target="_blank"
                rel="noopener noreferrer"
                icon={"instagram"}
                content={"Instagram"}
              />
              <List.Item
                as="a"
                href="https://www.facebook.com/The-Art-Collection-371804406621068/"
                target="_blank"
                rel="noopener noreferrer"
                icon={"facebook"}
                content={"Facebook"}
              />
              <List.Item
                as="a"
                href="https://twitter.com/artcollectionio"
                target="_blank"
                rel="noopener noreferrer"
                icon={"twitter"}
                content={"Twitter"}
              />
              <List.Item
                as="a"
                href="https://www.linkedin.com/company/artcollection-io"
                target="_blank"
                rel="noopener noreferrer"
                icon={"linkedin"}
                content={"LinkedIn"}
              />
            </List>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row style={{ paddingTop: "2em" }}>
          <Grid.Column floated={"left"}>
            <p style={{ color: "white", paddingLeft: "2em", bottom: 0 }}>
              © 2024 ArtCollection.io LLC. All rights reserved
            </p>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </footer>
  )
}
export default Footer
